import { render, staticRenderFns } from "./ShippingAdminForm.vue?vue&type=template&id=f916c8ac&scoped=true&"
import script from "./ShippingAdminForm.vue?vue&type=script&lang=js&"
export * from "./ShippingAdminForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAdminForm.vue?vue&type=style&index=0&id=f916c8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f916c8ac",
  null
  
)

export default component.exports